<template>
    <section 
        id="monitor-history-dialog" 
        class="monitor-history-dialog"
    >
        <v-dialog
            v-model="dialog"
            width="500"
        >
            <v-card class="container">
                <v-card-text class="text_area">
                    日間隔請勿超過十天，請重新選擇日期!
                </v-card-text>

                <v-divider />

                <v-card-actions class="btn_area">
                    <!-- <v-spacer /> -->
                    <v-btn
                        color="primary"
                        text
                        @click="close_hint_dialog"
                    >
                        我已了解
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </section>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        name: 'QpeDialogHistory',

        props: {
            is_open_dialog: {
                type: Boolean,
                default: false
            }
        }, 

        data() {
            return {
                dialog: false,
            }
        },

        computed: {
        },

        mounted () {
     
        },

        watch: {
            is_open_dialog: {
                handler(newV) {
                    this.dialog = newV;
                }
            }
        },


        methods: {
            close_hint_dialog () {
                this.dialog = false;
                this.$emit('close_hint_dialog');
            },
        },
    }
</script>

<style lang="scss" scoped>
    .container{
        padding: 18px 5px 0 5px;

        .text_area {
            font-size: 18px;
            text-align: center;
        }
        .btn_area {
            display: flex;
            justify-content: center;
        }
    }
</style>